import { UPDATE_USER_SUCCESS } from "../types/user"
import { ADD_BAZAAR_INTEREST_SUCCESS } from "../types/pvs"
import {
  // Login
  LOGIN_SUCCESS,

  // Logout
  LOGOUT_REQUEST,

  // User Profile
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  RESET_PROFILE_FLAG,

  // Forgot Password
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,

  // Social Login
  SOCIAL_LOGIN_REQUEST,
  SOCIAL_LOGIN_SUCCESS,
  SOCIAL_LOGIN_FAILURE,

  // Reset State
  RESET_AUTH_STATE,
  GET_OTP_PVS_SUCCESS,
  AWARDS_FLOW_INVOKED,
  SIGNUP_SUCCESS,
  GET_USER_DETAILS_SUCCESS,
  GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_SUCCESS,
} from "../types/auth"

const initialState = {
  // User data
  user: null,
  token: null,
  dashboard_redirection_type: null,
  pvs_cards: null,
  pvsOtpResult: null,
  pvsOtpMessage: "null",
  awards_flow_invoked: false,
  awards: null,
  activities: [],
  adminDashboardData: null,
  adminDashboardLoading: false,
  adminDashboardError: null,
  adminDashboardInfo: null,
  dashboardData: null,
}

const authReducer = function (state = initialState, action) {
  switch (action.type) {
    // =========== Login ===========
    case GET_OTP_PVS_SUCCESS:
      return {
        ...state,
        pvsOtpResult: action.payload.pvsOtpResult,
        pvsOtpMessage: action.payload.message,
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        dashboard_redirection_type: action.payload.dashboard_redirection_type,
        pvs_cards: action.payload.pvs_cards,
        awards: action.payload.awards,
      }

    case SIGNUP_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        dashboard_redirection_type: action.payload.dashboard_redirection_type,
        pvs_cards: action.payload.pvs_cards,
        awards: action.payload.awards,
      }

    case GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        pvs_cards: action.payload.pvs_cards,
        awards: action.payload.awards,
        activities: action.payload.all_activity_list,
      }

    case GET_ADMIN_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        adminDashboardInfo: action.payload.data,
      }

    // =========== Dashboard Data ===========

    case GET_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        dashboardData: action.payload.data,
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        // token: action.payload.token,
        dashboard_redirection_type: action.payload.dashboard_redirection_type,
        pvs_cards: action.payload.pvs_cards,
      }

    // =========== Logout ===========
    case LOGOUT_REQUEST:
      return initialState

    // =========== User Profile ===========
    case GET_USER_REQUEST:
      return Object.assign({}, state, {
        profileLoading: true,
        profileError: null,
      })
    case GET_USER_SUCCESS:
      return Object.assign({}, state, {
        profileLoading: false,
        isAuthenticated: true,
        user: action.payload,
        profileError: null,
      })
    case GET_USER_FAILURE:
      return Object.assign({}, state, {
        profileLoading: false,
        isAuthenticated: false,
        user: null,
        profileError: action.payload,
      })
    case UPDATE_PROFILE_SUCCESS:
    // return Object.assign({}, state, {
    //   profileLoading: false,
    //   user: Object.assign({}, state.user, action.payload),
    //   profileError: null,
    //   profileSuccess: "Profile updated successfully",
    // })
    case RESET_PROFILE_FLAG:
      return Object.assign({}, state, {
        profileError: null,
        profileSuccess: null,
      })

    // =========== Forgot Password ===========
    case FORGOT_PASSWORD_REQUEST:
      return Object.assign({}, state, {
        forgotPasswordLoading: true,
        forgotPasswordError: null,
        forgotPasswordSuccess: null,
      })
    case FORGOT_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        forgotPasswordLoading: false,
        forgotPasswordError: null,
        forgotPasswordSuccess: action.payload,
      })
    case FORGOT_PASSWORD_FAILURE:
      return Object.assign({}, state, {
        forgotPasswordLoading: false,
        forgotPasswordError: action.payload,
        forgotPasswordSuccess: null,
      })

    // =========== Social Login ===========
    case SOCIAL_LOGIN_REQUEST:
      return Object.assign({}, state, {
        socialLoading: true,
        socialError: null,
      })
    case SOCIAL_LOGIN_SUCCESS:
      return Object.assign({}, state, {
        socialLoading: false,
        isAuthenticated: true,
        user: action.payload.user,
        socialError: null,
      })
    case SOCIAL_LOGIN_FAILURE:
      return Object.assign({}, state, {
        socialLoading: false,
        socialError: action.payload,
      })

    case AWARDS_FLOW_INVOKED:
      return {
        ...state,
        awards_flow_invoked: action.payload.flag,
      }

    // =========== Reset State ===========
    case RESET_AUTH_STATE:
      return Object.assign({}, state, {
        error: null,
        registerError: null,
        forgotPasswordError: null,
        forgotPasswordSuccess: null,
        profileError: null,
        profileSuccess: null,
        socialError: null,
      })

    default:
      return state
  }
}

export default authReducer
